import { useState } from "react";
import { Star } from "lucide-react";

export function StarsDisplay({ value, size = "h-3 w-3", showNumber = false, count }) {
  const v = value || 0;
  return (
    <span className="inline-flex items-center gap-0.5 text-amber-400" data-testid="stars-display">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star key={i} className={`${size} ${i <= Math.round(v) ? "fill-amber-400 text-amber-400" : "text-slate-700"}`} />
      ))}
      {showNumber && v > 0 && <span className="text-slate-400 text-xs ml-1">{v.toFixed(1)}{count != null ? ` (${count})` : ""}</span>}
    </span>
  );
}

export function StarInput({ label, value, onChange, testid }) {
  const [hover, setHover] = useState(0);
  return (
    <div className="flex items-center justify-between gap-3" data-testid={testid}>
      <span className="text-sm text-slate-300">{label}</span>
      <div className="flex items-center gap-0.5">
        {[1, 2, 3, 4, 5].map((i) => (
          <button
            key={i}
            type="button"
            data-testid={`${testid}-star-${i}`}
            onMouseEnter={() => setHover(i)}
            onMouseLeave={() => setHover(0)}
            onClick={() => onChange(i)}
            className="p-0.5"
          >
            <Star className={`h-5 w-5 transition-colors ${i <= (hover || value) ? "fill-amber-400 text-amber-400" : "text-slate-700 hover:text-slate-500"}`} />
          </button>
        ))}
      </div>
    </div>
  );
}
